import { parseLabelFromString } from 'contexts';
import { featureEnabled } from 'utils';

angular.module('bb.listing_search').component('bbListingSearchTable', {
  bindings: {
    search: '<',
    sort: '<',
    showPreview: '<',
    listings: '<',
    favorites: '<',
    selectListing: '<',
    listingsToSend: '=?',
    viewListing: '<',
    listingTypes: '<',
    auth: '<',
    openContactDrawer: '<',
    showExpiry: '<',
  },
  controller: ListingSearchTableController,
  controllerAs: 'vm',
  template: require('./listing_search_table.html'),
});

ListingSearchTableController.$inject = ['$rootScope'];
function ListingSearchTableController($rootScope) {
  const vm = this;
  vm.changePreviewListing = listing => {
    vm.previewListing = listing;
  };
  vm.hasSupraRebrandingFeature = featureEnabled('supraRebrandingFeature', 1);
  $rootScope.$watch('labelOverrideMap', () => {
    vm.getLabel = label =>
      $rootScope.labelOverrideMap[parseLabelFromString(label)]?.label || label;

    vm.displayedField = () =>
      vm.getLabel('Neighborhood Display')?.trim().toUpperCase() === 'COUNTY'
        ? 'county'
        : 'neighborhood';
  });
}
